export default "__VITE_ASSET__5519dabd__"